import React, { useState } from "react";

const NotebookIcon = ({ chatHistoryId, onClick }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  // スマホでタッチしたらツールチップを一瞬だけ表示
  const handleTouch = () => {
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 1000); // 1秒後に非表示
  };

  const Tooltip = () => (
    <div className="absolute top-[25px] left-0 rounded-md text-white bg-gray-600 w-[160px] py-2 px-3 z-[9999] text-center">
      Insight Noteに保存
    </div>
  );

  return (
    <div
      className="div-icon-underbar"
      onClick={() => onClick(chatHistoryId)}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onTouchStart={handleTouch} // スマホ用
    >
      <i className="fa-solid fa-book text-gray-600 text-lg hover:text-gray-300"></i>
      {showTooltip && <Tooltip />}
    </div>
  );
};

export default NotebookIcon;
